
import { ICache } from "./ICache";

export class MemoryCache implements ICache {
    private _map = new Map<string, any>();
    private _disableClone: boolean;
    /**
     * @param {any} key: Unique key for the cached value
     * @param {any} getter Getter function for the cached value in case it has not been cached under the provided key. Useful if you do not want to make if statements for Get/Set.
     */

    constructor(disableClone?: boolean) {
        this._disableClone = !!disableClone;
    }
    public get<T>(key: string, getter?: () => T): T | undefined {
        if (!this._map.get(key) && getter) {
            this._map.set(key, getter());
        }
        return this._disableClone ? this._map.get(key) : structuredClone(this._map.get(key));
    }
    public set<T>(key: string, value: T) {
        this._map.set(key, value);
    }
    public delete(key: string) {
        this._map.delete(key);
    }
}
